export default "/images/95812f1ce7fc1c213fd97b61d788d287.avif";